import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Col,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap'

class AssignAdmin extends React.Component {
  static propType = {
    defaultAdminEmail: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      formName: 'assign-admin',
      iAmAdmin: false,
      email: '',
      confirmEmail: '',
      validation: {},
      isValid: false,
    }
  }

  handleBlur = e => this.validate.element(e.target)

  handleChangeIAmAdmin = e => {
    const checked = e.target.checked
    const partialState = {
      iAmAdmin: checked,
      email: checked ? this.props.defaultAdminEmail : '',
      confirmEmail: checked ? this.props.defaultAdminEmail : '',
    }

    this.setState(partialState, () => {
      if (checked) {
        // validate emails (after state set)
        let el = document.getElementsByName('email')[0]
        this.validate.element(el)
        el = document.getElementsByName('confirmEmail')[0]
        this.validate.element(el)
      }
      this.sendToParent()
    })
  }

  handleChange = e => {
    if (!e || !e.target || (!e.target.readonly && !e.target.name)) return
    const el = e.target
    const elementName = el.name
    const newValue = this.extractValue(el)
    const newState = this.state
    newState[elementName] = newValue
    this.setState(newState, () => {
      if (elementName === 'email' || elementName === 'confirmEmail') {
        this.sendToParent()
      }
    })
  }

  sendToParent = () => {
    const { onSelect } = this.props
    const { iAmAdmin, email, confirmEmail } = this.state
    onSelect({
      email: email,
      confirmEmail: iAmAdmin ? email : confirmEmail,
    })
  }

  validate = {
    element: (el, show = true) => {
      if (!el || !el.name) {
        console.debug('cannot validate element', el)
        return
      }
      const toValidate = el.name
      const valid = el.checkValidity()
      const v = this.state.validation
      if (show) {
        v[toValidate] = valid
        this.setState({ validation: v })
      }
      return valid
    },

    form: (show = false) => {
      const { formName } = this.state
      let valid = true
      const form = document.getElementsByName(formName)[0]
      const inputs = form.querySelectorAll('input, select')
      for (let i = 0; i < inputs.length; i++) {
        if (!this.validate.element(inputs[i], show)) {
          valid = false
          return valid
        }
      }
      return valid
    },

    getClassName: id => {
      switch (this.state.validation[id]) {
        case true:
          return 'is-valid'
        case false:
          return 'is-invalid'
        default:
          return ''
      }
    },
  }

  extractValue = el => {
    if (!el) return null
    const inputType = el.type
    switch (inputType) {
      case 'checkbox':
      case 'radio':
        return el.checked
      default:
        return el.value
    }
  }

  render = () => {
    const labelWidth = 3
    const fieldWidth = 9
    const { formName, email, confirmEmail, iAmAdmin } = this.state

    return (
      <Form name={formName} noValidate>
        <p className="float-right">* Required Field</p>
        <h4>Assign License Administrator</h4>
        <FormText>
          Designate a responsible for assigning the user(s) and additional
          License Administrators.
        </FormText>
        <hr />
        {this.props.defaultAdminEmail && (
          <FormGroup row>
            <Label sm={labelWidth}>{/* spacer */}</Label>
            <Label check sm={fieldWidth} style={{ paddingLeft: '2rem' }}>
              <Input
                checked={iAmAdmin}
                name="iAmAdmin"
                onChange={this.handleChangeIAmAdmin}
                type="checkbox"
              />{' '}
              I will be a License Administrator
            </Label>
          </FormGroup>
        )}
        <FormGroup row>
          <Label for="email" sm={labelWidth}>
            Email *
          </Label>
          <Col sm={fieldWidth}>
            <Input
              aria-required="true"
              className={this.validate.getClassName('email')}
              disabled={iAmAdmin}
              name="email"
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              pattern="^(([^<>()\[\]\\.,;:\s@]+(\.[^<>()\[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$"
              placeholder="Email"
              required
              type="text"
              value={email || ''}
            />
            <FormFeedback tooltip>Enter a valid Email Address.</FormFeedback>
          </Col>
        </FormGroup>
        {!iAmAdmin && (
          <FormGroup row>
            <Label for="email" sm={labelWidth}>
              Confirm Email *
            </Label>
            <Col sm={fieldWidth}>
              <Input
                aria-required="true"
                className={this.validate.getClassName('confirmEmail')}
                disabled={iAmAdmin}
                name="confirmEmail"
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                pattern={email}
                placeholder="Confirm Email"
                required
                type="text"
                value={confirmEmail || ''}
              />
              <FormFeedback tooltip>
                Confirmation Email is not valid or does not match.
              </FormFeedback>
            </Col>
          </FormGroup>
        )}
      </Form>
    )
  }
}

export default connect()(AssignAdmin)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/setupLicense/AssignAdmin.js